import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';
import { ONBOARDING_TEMPLATE_RESOURCE } from '../../constants';

import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: ONBOARDING_TEMPLATE_RESOURCE,
      method: 'get',
      request: (id, rejectCallback, t) => ({
        url: apiRoutes.onboardingTemplates(id),
        meta: {
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getOnboardingTemplateFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
